var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddGreenOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62475 6.37525C9.85688 6.37525 10.0795 6.28304 10.2436 6.1189C10.4078 5.95475 10.5 5.73213 10.5 5.5C10.5 5.26787 10.4078 5.04525 10.2436 4.8811C10.0795 4.71696 9.85688 4.62475 9.62475 4.62475H6.12525V1.12525C6.12525 0.893119 6.03304 0.670496 5.8689 0.506355C5.70475 0.342214 5.48213 0.25 5.25 0.25C5.01787 0.25 4.79525 0.342214 4.6311 0.506355C4.46696 0.670496 4.37475 0.893119 4.37475 1.12525V4.62475H0.87525C0.643119 4.62475 0.420496 4.71696 0.256355 4.8811C0.0922136 5.04525 0 5.26787 0 5.5C0 5.73213 0.0922136 5.95475 0.256355 6.1189C0.420496 6.28304 0.643119 6.37525 0.87525 6.37525H4.37475V9.87475C4.37475 10.1069 4.46696 10.3295 4.6311 10.4936C4.79525 10.6578 5.01787 10.75 5.25 10.75C5.48213 10.75 5.70475 10.6578 5.8689 10.4936C6.03304 10.3295 6.12525 10.1069 6.12525 9.87475V6.37525H9.62475Z",
    fill: "#10A37F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddGreenOutline);
export default __webpack_public_path__ + "static/media/AddGreenOutline.be61557e3ca074c485ea8fe7e6b4bd72.svg";
export { ForwardRef as ReactComponent };